import React from "react";
import { Modal } from "react-bootstrap";
import { StudentCourseDailyReportInsertDTO } from "../../../models/dtos/work-reports/StudentCourseDailyReportInsertDTO";
import { StudentDailyReportInsertDTO } from "../../../models/dtos/work-reports/StudentDailyReportInsertDTO";
import StudentDailyReports from "../../../services/work-report/StudentDailyReports";
import { StudentCourseDailyReportView } from "../submit-report/SubmitReport.models";
import ConfirmReportModalState, {
  ConfirmReportModalProps,
} from "./ConfirmReportModal.models";
import html2canvas from "html2canvas";

export default class ConfirmReportModal extends React.PureComponent<
  ConfirmReportModalProps,
  ConfirmReportModalState
> {
  studentDailyReports: StudentDailyReports;
  courseListRef: React.RefObject<any>;

  constructor(props: any) {
    super(props);
    this.courseListRef = React.createRef();
    this.studentDailyReports = new StudentDailyReports();
    this.state = { disableButton: false };
  }

  captureDiv = async () => {
    const el = this.courseListRef.current as HTMLElement | null;
    if (!el) return;

    if (document.fonts?.ready) {
      // @ts-ignore
      await document.fonts.ready;
    }

    const prev = {
      height: el.style.height,
      overflow: el.style.overflow,
      maxHeight: el.style.maxHeight,
      scrollTop: el.scrollTop,
    };

    el.scrollTop = 0;
    el.style.height = `${el.scrollHeight}px`;
    el.style.maxHeight = "none";
    el.style.overflow = "visible";

    await new Promise((r) => setTimeout(r, 50));

    const canvas = await html2canvas(el, {
      backgroundColor: "#fff",
      useCORS: true,
      allowTaint: false,
      scale: Math.min(2, window.devicePixelRatio || 1),
      logging: false,
    });

    el.style.height = prev.height;
    el.style.maxHeight = prev.maxHeight;
    el.style.overflow = prev.overflow;
    el.scrollTop = prev.scrollTop;

    const image = canvas.toDataURL("image/png");
    const link = document.createElement("a");
    link.href = image;
    link.download = "daily-report.png";
    link.click();
  };

  success = () => {
    let self = this;
    let propsCourses = this.props.courses;

    if (this.state.disableButton) return;

    this.setState({ disableButton: true });
    this.forceUpdate();

    var convertedCourses: StudentCourseDailyReportInsertDTO[] =
      propsCourses.map((item) => ({
        courseID: item.courseID,
        studyTextResult: item.studyTextResult,
        testPassedCount: item.testPassedCount ?? 0,
        studyTime: {
          hour: item.studyTimeHour ?? 0,
          minute: item.studyTimeMinute ?? 0,
        },
      }));

    var request: StudentDailyReportInsertDTO = {
      isLiked: this.props.isLiked,
      sleepTime: this.props.sleepTime,
      wakeUpTime: this.props.wakeUpTime,
      electronicUsageTime: this.props.electronicUsageTime,
      courses: convertedCourses,
    };

    this.studentDailyReports.insert(request).then(function (response) {
      if (response.status === 200) {
        self.props.closeModal();
        window.location.href = "/Dashboard";
      }
    });

    setInterval(() => {
      this.setState({ disableButton: false });
    }, 2000);
  };

  basicInformationView() {
    let { sleepTime, wakeUpTime, electronicUsageTime } = this.props;

    return (
      <div>
        <div>
          <label>
            <b>ساعت بیداری : </b>
            {sleepTime.hour ?? 0}:{sleepTime.minute ?? 0}
          </label>
        </div>
        <div>
          <label>
            <b>ساعت خواب: </b>
            {wakeUpTime.hour ?? 0}:{wakeUpTime.minute ?? 0}
          </label>
        </div>
        <div>
          <label>
            <b>میزان استفاده از فضای مجازی: </b>
            {electronicUsageTime.hour ?? 0}:{electronicUsageTime.minute ?? 0}
          </label>
        </div>
      </div>
    );
  }

  render(): React.ReactNode {
    let { showModal, closeModal, courses } = this.props;
    return (
      <>
        <Modal show={showModal} onHide={closeModal} animation={true}>
          <Modal.Header>
            <Modal.Title>
              <label>ثبت گزارش کار </label>
            </Modal.Title>
          </Modal.Header>

          <Modal.Body style={{ textAlign: "right" }} dir={"ltr"}>
            <div className="bd-modal">
              <label>آیا از صحت اطلاعات گزارش خود مطمئن هستید؟</label>
            </div>
            <div
              ref={this.courseListRef}
              style={{
                height: 400,
                overflow: "auto",
                padding: "8px",
              }}
            >
              {this.basicInformationView()}
              <hr />
              {this.courseListView(courses)}
            </div>
          </Modal.Body>

          <Modal.Footer dir="ltr">
            <button className="btn btn btn-success" onClick={this.captureDiv}>
              دانلود
            </button>
            <form>
              <input
                type="submit"
                value="بله"
                onClick={this.success}
                className="btn btn btn-primary"
                disabled={this.state.disableButton}
              />
            </form>
            <button
              className="btn btn btn-outline-primary"
              onClick={closeModal}
            >
              {" "}
              ویرایش گزارش کار
            </button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }

  courseListView(courses: StudentCourseDailyReportView[]) {
    let content;
    if (courses !== null && courses.length > 0)
      content = (
        <>
          {courses.map((course, key) => {
            return (
              <div key={key}>
                <div>
                  <div>
                    <label>
                      <b>
                        <i
                          className="mdi mdi-book-open-page-variant"
                          style={{ color: "#d5912a" }}
                        ></i>{" "}
                        نام درس :{" "}
                      </b>
                      {course.courseTitle}{" "}
                    </label>
                  </div>
                  <div>
                    <label>
                      <b>
                        <i
                          className="mdi mdi-head-lightbulb-outline"
                          style={{ color: "#008500" }}
                        ></i>{" "}
                        نتیجه مطالعه :
                      </b>{" "}
                      {course.studyTextResult}{" "}
                    </label>
                  </div>
                  <div>
                    <label>
                      <b>
                        <i
                          className="mdi mdi-clipboard-list-outline"
                          style={{ color: "#8a35bf" }}
                        ></i>{" "}
                        تعداد تست :
                      </b>{" "}
                      {course.testPassedCount !== null
                        ? course.testPassedCount
                        : "تست نزده بودید"}{" "}
                    </label>
                  </div>
                  <div>
                    <label>
                      <b>
                        <i
                          className="mdi mdi-clock-outline"
                          style={{ color: "#c50202" }}
                        ></i>{" "}
                        ساعت مطالعه :
                      </b>{" "}
                      {course.studyTimeHour ?? 0} ساعت و{" "}
                      {course.studyTimeMinute ?? 0} دقیقه{" "}
                    </label>
                  </div>
                </div>
                {courses.indexOf(course) !==
                courses.indexOf(courses[courses.length - 1]) ? (
                  <>
                    <br />
                    <hr />
                  </>
                ) : (
                  <></>
                )}
              </div>
            );
          })}
        </>
      );
    else content = <></>;
    return <>{content}</>;
  }
}
